/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import calender from '../../../public/assets/calendar-20.png';
import fallBackIcon from '../../../public/assets/Icon.png';

export default function ListCard({ content, isslugPage = false }) {
  const {
    id, name, createdAt, thumbnail, slug,
  } = content;
  const router = useRouter();
  const formatCreatedAt = (timeStamp) => {
    if (!timeStamp) return '';

    return new Date(Number(timeStamp)).toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
  };

  const handleCardClick = () => {
    if (isslugPage && slug?.slug) {
      router.push(`/${slug?.slug}`);
      return;
    }
    router.push(`/view-all/${id}`);
  };

  return (
    <div className="w-full bg-white rounded-2xl shadow-sm p-4 flex items-center justify-between relative cursor-pointer" onClick={handleCardClick}>
      <div className="flex items-start gap-4">
        <Image
          src={thumbnail || fallBackIcon}
          alt={name}
          width={80}
          height={80}
          className="w-30 h-30 rounded-md"
        />
        <div className="flex flex-col gap-1">
          <h3 className="text-lg font-semibold w-[350px] line-clamp-1">{name}</h3>
          <div className="flex items-center gap-1 text-base mt-3">
            <Image
              src={calender}
              alt="calender-icon"
              width={80}
              height={80}
              className="w-5 h-5"
            />
            <span>{formatCreatedAt(createdAt)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

ListCard.propTypes = {
  content: PropTypes.array,
  isslugPage: PropTypes.bool,
};
